import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useBreakpoints } from "@/Composables/useBreakpoints";

export const useClickOutside = (elementRef, callback, options = {}) => {
    const { handleOnMobile = true } = options;
    const element = ref(null);

    const { maxSmall } = useBreakpoints();

    onMounted(() => {
        element.value = elementRef.value;
        registerListener();
    });

    onBeforeUnmount(() => {
        unregisterListener();
    });

    if (!handleOnMobile) {
        watch(maxSmall, (value) => {
            if (value) {
                unregisterListener();
            } else {
                registerListener();
            }
        });
    }

    const registerListener = () => {
        if (handleOnMobile || !maxSmall.value) {
            document.addEventListener("click", handleClickOutside);
        }
    };

    const unregisterListener = () => {
        document.removeEventListener("click", handleClickOutside);
    };

    function handleClickOutside(event) {
        if (
            event.target === element.value ||
            event.composedPath().includes(element.value)
        ) {
            return;
        }
        if (typeof callback === "function") {
            callback();
        }
    }
};
